﻿/* ================================================================
   Custom Hydraulic Hose Price Calculator  v1
   Product: custom-hydraulic-hose  |  Variant price: $0.01
   Quantity encodes price-in-cents for order total accuracy.
   Architecture mirrors the proven custom-cable-calculator.js
   (live DOM re-query, event delegation, $0.01-quantity-encodes-price cart technique, cart quantity-display override).
   ================================================================ */

(function () {
  'use strict';

  var RATE_PER_INCH = {
    '1/4"': 0.60,
    '3/8"': 0.75
  };

  var FITTINGS = {
    'FJX-04-04':   { label: '1/4" JIC 37\u00b0 Flare Female Swivel',          hoseSize: '1/4"', portSize: '1/4"', priceUSD: 12.00 },
    'FJX90-04-04': { label: '1/4" JIC 37\u00b0 Flare Female Swivel 90\u00b0', hoseSize: '1/4"', portSize: '1/4"', priceUSD: 29.43 },
    'FJX45-04-04': { label: '1/4" JIC 37\u00b0 Flare Female Swivel 45\u00b0', hoseSize: '1/4"', portSize: '1/4"', priceUSD: 32.73 },
    'FJX-04-06':   { label: '3/8" JIC 37\u00b0 Flare Female Swivel',          hoseSize: '1/4"', portSize: '3/8"', priceUSD: 11.64 },
    'FJX90-04-06': { label: '3/8" JIC 37\u00b0 Flare Female Swivel 90\u00b0', hoseSize: '1/4"', portSize: '3/8"', priceUSD: 32.85 },
    'FJX45-04-06': { label: '3/8" JIC 37\u00b0 Flare Female Swivel 45\u00b0', hoseSize: '1/4"', portSize: '3/8"', priceUSD: 34.32 },
    'MPX-04-04':   { label: '1/4" Male Pipe Thread (NPTF) Swivel',             hoseSize: '1/4"', portSize: '1/4"', priceUSD: 21.99 },
    'MPX-04-06':   { label: '3/8" Male Pipe Thread (NPTF) Swivel',             hoseSize: '1/4"', portSize: '3/8"', priceUSD: 30.36 },
    'FJX-06-04':   { label: '1/4" JIC 37\u00b0 Flare Female Swivel',          hoseSize: '3/8"', portSize: '1/4"', priceUSD: 41.58 },
    'FJX90-06-04': { label: '1/4" JIC 37\u00b0 Flare Female Swivel 90\u00b0', hoseSize: '3/8"', portSize: '1/4"', priceUSD: 34.98 },
    'FJX45-06-04': { label: '1/4" JIC 37\u00b0 Flare Female Swivel 45\u00b0', hoseSize: '3/8"', portSize: '1/4"', priceUSD: 38.46 },
    'MPX-06-04':   { label: '1/4" Male Pipe Thread (NPTF) Swivel',             hoseSize: '3/8"', portSize: '1/4"', priceUSD: 24.36 },
    'FJX-06-06':   { label: '3/8" JIC 37\u00b0 Flare Female Swivel',          hoseSize: '3/8"', portSize: '3/8"', priceUSD: 14.31 },
    'FJX90-06-06': { label: '3/8" JIC 37\u00b0 Flare Female Swivel 90\u00b0', hoseSize: '3/8"', portSize: '3/8"', priceUSD: 32.55 },
    'FJX45-06-06': { label: '3/8" JIC 37\u00b0 Flare Female Swivel 45\u00b0', hoseSize: '3/8"', portSize: '3/8"', priceUSD: 44.64 },
    'MPX-06-06':   { label: '3/8" Male Pipe Thread (NPTF) Swivel',             hoseSize: '3/8"', portSize: '3/8"', priceUSD: 19.89 }
  };

  function calcTotalPrice(hoseSize, fitting1Key, fitting2Key, lengthIn) {
    var rate = RATE_PER_INCH[hoseSize];
    if (rate === undefined) return null;
    var f1 = FITTINGS[fitting1Key];
    var f2 = FITTINGS[fitting2Key];
    if (!f1 || !f2) return null;
    var price = (rate * lengthIn) + f1.priceUSD + f2.priceUSD;
    return Math.round(price * 100) / 100;
  }

  function fmtMoney(n) { return '$' + n.toFixed(2); }

  function getWrap()         { return document.getElementById('ch-calc-wrap'); }
  function getHoseRadios()   { return [].slice.call(document.querySelectorAll('input[name="ch-hose-size"]')); }
  function getInputInches()  { return document.getElementById('ch-inches'); }
  function getPriceDisplay() { return document.getElementById('ch-price-amount'); }
  function getAddBtn()       { return document.getElementById('ch-add-btn'); }
  function getMsgSuccess()   { return document.getElementById('ch-msg-success'); }
  function getMsgError()     { return document.getElementById('ch-msg-error'); }

  function getF1Options()    { return [].slice.call(document.querySelectorAll('.ch-f1-option')); }
  function getF2Options()    { return [].slice.call(document.querySelectorAll('.ch-f2-option')); }
  function getF1Radios()     { return [].slice.call(document.querySelectorAll('input[name="ch-fitting1"]')); }
  function getF2Radios()     { return [].slice.call(document.querySelectorAll('input[name="ch-fitting2"]')); }

  function filterFittings(hoseSize) {
    function filterGroup(optEls) {
      optEls.forEach(function (opt) {
        var available = opt.getAttribute('data-fitting-hose') === hoseSize;
        if (available) {
          opt.classList.add('cc-end-option--visible');
        } else {
          opt.classList.remove('cc-end-option--visible');
          var radio = opt.querySelector('input[type="radio"]');
          if (radio && radio.checked) radio.checked = false;
        }
      });
      var anyChecked = optEls.some(function (o) {
        return o.classList.contains('cc-end-option--visible') &&
               o.querySelector('input[type="radio"]').checked;
      });
      if (!anyChecked) {
        var first = optEls.filter(function (o) { return o.classList.contains('cc-end-option--visible'); })[0];
        if (first) first.querySelector('input[type="radio"]').checked = true;
      }
    }
    filterGroup(getF1Options());
    filterGroup(getF2Options());
  }

  function getState() {
    var hoseRadios = getHoseRadios();
    var f1Radios   = getF1Radios();
    var f2Radios   = getF2Radios();
    var iInches    = getInputInches();
    var hoseSize = (function () { var r = hoseRadios.filter(function (r) { return r.checked; })[0]; return r ? r.value : ''; })();
    var f1       = (function () { var r = f1Radios.filter(function (r) { return r.checked; })[0]; return r ? r.value : ''; })();
    var f2       = (function () { var r = f2Radios.filter(function (r) { return r.checked; })[0]; return r ? r.value : ''; })();
    var lengthIn = parseFloat(iInches ? iInches.value : 0) || 0;
    return { hoseSize: hoseSize, f1: f1, f2: f2, lengthIn: lengthIn };
  }

  function getMismatchBox() { return document.getElementById('ch-mismatch-warning'); }

  function updateSizeMismatchWarning(s) {
    var box = getMismatchBox();
    if (!box) return;
    var f1 = FITTINGS[s.f1];
    var f2 = FITTINGS[s.f2];
    if (!s.hoseSize || !f1 || !f2) { box.style.display = 'none'; box.textContent = ''; return; }
    var otherSize = s.hoseSize === '1/4"' ? '3/8"' : '1/4"';
    var bothOtherSize = f1.portSize === otherSize && f2.portSize === otherSize;
    if (!bothOtherSize) { box.style.display = 'none'; box.textContent = ''; return; }
    box.textContent = 'You have selected a ' + s.hoseSize + ' Hose with Both Fittings ' + otherSize + '. It is highly recommended when possible to match the fitting sizes with the hose size. Please verify before adding to cart.';
    box.style.display = 'block';
  }

  function recalc() {
    var priceDisplay = getPriceDisplay();
    var addBtn       = getAddBtn();
    if (!priceDisplay || !addBtn) return;
    var s = getState();
    updateSizeMismatchWarning(s);
    if (!s.hoseSize || !s.f1 || !s.f2 || s.lengthIn <= 0) {
      priceDisplay.textContent = '--';
      addBtn.disabled = true;
      return;
    }
    var price = calcTotalPrice(s.hoseSize, s.f1, s.f2, s.lengthIn);
    if (price === null) {
      priceDisplay.textContent = '--';
      addBtn.disabled = true;
      return;
    }
    priceDisplay.textContent = fmtMoney(price);
    addBtn.disabled = false;
  }

  window.chRecalc = recalc;

  function buildLengthLabel() {
    return (parseFloat(getInputInches() ? getInputInches().value : 0) || 0) + ' in';
  }

  function findFittingLabel(key) {
    var f = FITTINGS[key];
    return f ? f.label : key;
  }

  var isAdding = false;

  function addToCart() {
    if (isAdding) return;
    var wrap = getWrap();
    if (!wrap) return;
    var variantId = wrap.getAttribute('data-variant-id');
    if (!variantId) return;
    var s = getState();
    if (!s.hoseSize || !s.f1 || !s.f2 || s.lengthIn <= 0) return;
    var price = calcTotalPrice(s.hoseSize, s.f1, s.f2, s.lengthIn);
    if (price === null) return;
    isAdding = true;
    var qtyCents = Math.round(price * 100);
    var addBtn   = getAddBtn();
    var msgOk    = getMsgSuccess();
    var msgErr   = getMsgError();
    var payload = {
      id: variantId,
      quantity: qtyCents,
      properties: {
        'Hose Diameter':     s.hoseSize,
        'Fitting 1':         findFittingLabel(s.f1),
        'Fitting 2':         findFittingLabel(s.f2),
        'Length':            buildLengthLabel(),
        '_calculated_price': fmtMoney(price)
      }
    };
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding\u2026'; }
    if (msgOk)  msgOk.style.display  = 'none';
    if (msgErr) msgErr.style.display = 'none';
    var cartAddUrl = (window.Shopify && Shopify.routes && Shopify.routes.root)
      ? Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';
    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function () {
      isAdding = false;
      var btn = getAddBtn();
      if (btn) { btn.disabled = false; btn.textContent = 'Add Another Hose to Cart'; }
      var ok = getMsgSuccess();
      if (ok) ok.style.display = 'block';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var displayCount = 0;
          (cart.items || []).forEach(function (item) {
            var isCustomProduct = item.handle === 'custom-cable' ||
                                  item.handle === 'custom-hydraulic-hose' ||
                                  (item.properties && item.properties['_calculated_price']);
            displayCount += isCustomProduct ? 1 : item.quantity;
          });
          var countWrap = document.getElementById('CartCount');
          if (countWrap) {
            var badge = countWrap.querySelector('.count.CartCount') || countWrap.querySelector('.count') || countWrap;
            badge.textContent = displayCount;
            countWrap.setAttribute('data-cart_item_count', displayCount);
            if (displayCount === 0) countWrap.classList.add('hidden');
            else countWrap.classList.remove('hidden');
          }
        })
        .catch(function () {});
    })
    .catch(function (err) {
      isAdding = false;
      var btn = getAddBtn();
      if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
      var er = getMsgError();
      if (er) er.style.display = 'block';
      console.error('[CH] Add to cart error', err);
    });
  }

  function onChEvent(e) {
    var t = e.target;
    if (!t) return;
    var wrap = getWrap();
    if (!wrap || !wrap.contains(t)) return;
    var id   = t.id   || '';
    var name = t.name || '';
    if (id === 'ch-inches') { recalc(); return; }
    if (name === 'ch-hose-size') { filterFittings(t.value); recalc(); return; }
    if (name === 'ch-fitting1' || name === 'ch-fitting2') { recalc(); return; }
    if (id === 'ch-add-btn') { addToCart(); }
  }

  document.addEventListener('input',  onChEvent, true);
  document.addEventListener('change', onChEvent, true);
  document.addEventListener('click',  onChEvent, true);
  document.addEventListener('input',  onChEvent, false);
  document.addEventListener('change', onChEvent, false);
  document.addEventListener('click',  onChEvent, false);

  var _lastStateKey = '';
  function pollState() {
    try {
      var s = getState();
      var key = s.hoseSize + '|' + s.f1 + '|' + s.f2 + '|' + s.lengthIn;
      if (key !== _lastStateKey) { _lastStateKey = key; recalc(); }
    } catch (e) { /* ignore */ }
  }
  setInterval(pollState, 250);

  function boot() {
    setTimeout(function () {
      var s = getState();
      if (s.hoseSize) filterFittings(s.hoseSize);
      recalc();
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* NOTE: Cart quantity override for custom-hydraulic-hose is handled
     by the global assets/custom-cable-cart.js script (loaded site-wide
     via theme.liquid), which has been extended to also match
     /products/custom-hydraulic-hose. This per-page initCartOverride
     is kept as belt-and-suspenders for the cart PAGE only. */
  function initCartOverride() {
    function applyCartOverride() {
      var rows = document.querySelectorAll('.cart__row, .cart-item, [data-cart-item]');
      rows.forEach(function (row) {
        if (row.classList.contains('ch-cart-processed')) return;
        var link = row.querySelector('a[href*="/products/custom-hydraulic-hose"]');
        if (!link) return;
        row.classList.add('ch-cart-processed');
        var qtyInput = row.querySelector('input[name^="updates"], .quantity-selector, input.cart-number, input.quantity-btn-number');
        var minusBtn = row.querySelector('.qtyminus1, .quantity-btn-minus');
        var plusBtn  = row.querySelector('.qtyplus1, .quantity-btn-plus');
        if (minusBtn) minusBtn.style.display = 'none';
        if (plusBtn)  plusBtn.style.display  = 'none';
        if (qtyInput) {
          qtyInput.style.display = 'none';
          var staticQty = document.createElement('span');
          staticQty.className = 'cc-cart-qty-display';
          staticQty.textContent = '1 custom hose';
          staticQty.style.cssText = 'font-weight:600;padding:8px 0;display:inline-block;';
          if (qtyInput.parentNode) qtyInput.parentNode.insertBefore(staticQty, qtyInput);
        }
      });
    }
    applyCartOverride();
    document.addEventListener('cart:refresh', applyCartOverride);
    document.addEventListener('ajaxCart.afterReload', applyCartOverride);
    var observer = new MutationObserver(function () { applyCartOverride(); });
    var target = document.getElementById('CartContainer') || document.getElementById('CartDrawer') || document.body;
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  initCartOverride();

})();
